import {mock} from './index';

export default {
  getOrganizationList: () => mock('/admin/organization/list'),
  getOrganizationInfo: () => mock('/admin/organization/get'),
  uploadOrganizationLogo: () => mock('/admin/organization/logo/upload'),
  setOrganizationAdmin: () => mock('/admin/organization/admin/set'),
  createAndSetOrganizationAdmin: () => mock('/admin/organization/admin/createAndSet'),
  getWorkingOrganizationInfo: () => mock('/user/organization/get'),
  getDomainList: () => 'admin/organization/domain/list',
  modifyOrganizationLan: () => mock('/admin/organization/addition/modify'),
  getOrganizationCopyRight: () => mock('/organization/copyright/get'),
  setOrganizationCopyRight: () => mock('/admin/organization/copyright/set'),
  getOrganizationAdminInfo: () => mock('/organization/admin/info')
};
